import { useEffect, useState } from "react";
import axios from "../lib/axios";

const ADMIN_CHECK_TIMEOUT_MS = 2000;

export default function useAdminAuth() {
  const [loading, setLoading] = useState(true);
  const [loggedIn, setLoggedIn] = useState(false);
  const [role, setRole] = useState(null);
  const [username, setUsername] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await axios.get("/admin/check", { timeout: ADMIN_CHECK_TIMEOUT_MS });
        if (!alive) return;
        setLoggedIn(!!data.logged_in);
        setRole(data.role || null);
        setUsername(data.username || null);
      } catch {
        if (!alive) return;
        setLoggedIn(false);
        setRole(null);
        setUsername(null);
      } finally {
        if (!alive) return;
        setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  return { loading, loggedIn, role, username };
}
